export const slideDown = (element, duration = 500, display = 'block') => {
  element.style.removeProperty('display')

  let disp = window.getComputedStyle(element).display

  if (disp === 'none') {
    disp = display
  }

  element.style.display = disp

  const height = element.offsetHeight
  element.style.overflow = 'hidden'
  element.style.height = 0
  element.style.paddingTop = 0
  element.style.paddingBottom = 0
  element.style.marginTop = 0
  element.style.marginBottom = 0
  element.offsetHeight
  element.style.transitionProperty = 'height, margin, padding'
  element.style.transitionDuration = `${duration}ms`
  element.style.height = `${height}px`
  element.style.removeProperty('padding-top')
  element.style.removeProperty('padding-bottom')
  element.style.removeProperty('margin-top')
  element.style.removeProperty('margin-bottom')

  window.setTimeout(() => {
    element.style.removeProperty('height')
    element.style.removeProperty('overflow')
    element.style.removeProperty('transition-duration')
    element.style.removeProperty('transition-property')
  }, duration)
}

export default slideDown

// /**
//  * SlideToggle
//  *
//  * @param {HTMLElement} element
//  * @param {Number} duration
//  * @returns {Promise<boolean>}
//  */

// export const slideToggle = (element, duration = 500, display = 'block') => {
//   if (window.getComputedStyle(element).display === 'none') {
//     return slideDown(element, duration, display)
//   } else {
//     return slideUp(element, duration)
//   }
// }
